"use strict";

exports.__esModule = true;
exports.TUTORIAL_DISMISSED = exports.TUTORIAL_COMPLETE = exports.TUTORIAL_BEGIN = void 0;
var TUTORIAL_BEGIN = 'tutorial_begin';
exports.TUTORIAL_BEGIN = TUTORIAL_BEGIN;
var TUTORIAL_COMPLETE = 'tutorial_complete';
exports.TUTORIAL_COMPLETE = TUTORIAL_COMPLETE;
var TUTORIAL_DISMISSED = 'tutorial_dismissed';
exports.TUTORIAL_DISMISSED = TUTORIAL_DISMISSED;